/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Price_Setup_Not_ConfirmedInputs */

const en_error_price_setup_not_confirmed = /** @type {(inputs: Error_Price_Setup_Not_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Price Setup of the season is not confirmed yet.`)
};

/**
* | output |
* | --- |
* | "The Price Setup of the season is not confirmed yet." |
*
* @param {Error_Price_Setup_Not_ConfirmedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_price_setup_not_confirmed = /** @type {((inputs?: Error_Price_Setup_Not_ConfirmedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Price_Setup_Not_ConfirmedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_price_setup_not_confirmed(inputs)
});